import { combineReducers, configureStore } from "@reduxjs/toolkit";
import currentUserReducer from "./slices/currentUserSlice";
import selectedInvestmentForAppraisalReducer from "./slices/selectedInvestmentForAppraisalslice";
import userContextReducer from "./slices/userContextSlice";
import addUpdateInvestmentMasterReducer from "./slices/AddUpdateInvestmentMasterSlice";
import updateInvestmentAssetReducer from "./slices/InvestmentMasterAssetSlice";
import investmentAppraisalReducer from "./slices/UpdateInvestmentMasterAppraisalValueSlice"
import allApplicationUserReducer from "./slices/GetAllApplicationUserSlice";
import allFundForInvestmentReducer from "./slices/GetAllFundsForInvestmentMasterSlice";
import appraisalDetailsForUSAppraisalReducer from "./slices/AppraisalDetailsForUSAppraisalSlice";
import appraisalAssetsReducer from "./slices/AppraisalAssetsSlice";
import AppraisalDetailsForCMReducer from "./slices/AppraisalDetailsForCMSlice"
import addNewAttachmentsReducer from "./slices/AddNewAttachmentsSlice";
import updateExistingAttachmentsReducer from "./slices/UpdateExistingAttachmentSlice";
import appraisalDetailsForDLorDAReducer from "./slices/AppraisalDetailsForDLorDASlice";
import appraisalSubmitEventReducer from "./slices/AppraisalSubmitEventSlice";
import updateFlagToDisableControlesForAppraisalReducer from "./slices/DisableAppraisalControlsSlice";
import appraisalReducer from "./slices/AppraisalSlice";
import appraiser1ListReducer from "./slices/Appraiser1Slice";
import auditLogReducer from "./slices/AuditSlice";
import selectedGlobalFundReducer from "./slices/SelectedGlobalFundSlice";
import updateTodoListCountReducer  from "./slices/TodoListCountSlice";

const rootReducer = combineReducers({
  currentUser: currentUserReducer,
  SelectedInvestmentForAppraisal: selectedInvestmentForAppraisalReducer,
  UserContext: userContextReducer,
  AddUpdateInvestmentMaster: addUpdateInvestmentMasterReducer,
  UpdateInvestmentAsset: updateInvestmentAssetReducer,
  UpdateInvestmentMasterAppraisal: investmentAppraisalReducer,
  GetAllApplicationUsers: allApplicationUserReducer,
  GetAllFundsForInvestment: allFundForInvestmentReducer,
  AppraisalDetailsForUSAppraisal: appraisalDetailsForUSAppraisalReducer,
  AppraisalDetailsForCM: AppraisalDetailsForCMReducer,
  AppraisalAssets: appraisalAssetsReducer,
  AddNewAttachments: addNewAttachmentsReducer,
  UpdateExistingAttachments: updateExistingAttachmentsReducer,
  AppraisalDetailsForDLorDA: appraisalDetailsForDLorDAReducer,
  AppraisalSubmitEvent: appraisalSubmitEventReducer,
  updateTodoListCount : updateTodoListCountReducer,
  UpdateFlagToDisableControlesForAppraisal: updateFlagToDisableControlesForAppraisalReducer,
      USAppraisal:appraisalReducer,
      Appraiser1List : appraiser1ListReducer,
      auditLog : auditLogReducer,
      selectedGlobalFund : selectedGlobalFundReducer,
});


export const makeStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof makeStore>
export type AppDispatch = AppStore['dispatch']


export const store = makeStore();

